export const formEditIgnorePaths = [
  '/:prefix?/forms/:formId/custom',
  '/:prefix?/forms/:formId/custom/(.*)',
  '/:prefix?/forms/:formId/data',
  '/:prefix?/forms/:formId/quality-entry',
  '/:prefix?/forms/:formId/quality-entry/(.*)',
  '/:prefix?/forms/:formId/quality-section',
  '/:prefix?/forms/:formId/quality-section/(.*)',
  '/:prefix?/forms/:formId/risk-entry',
  '/:prefix?/forms/:formId/risk-entry/(.*)',
  '/:prefix?/forms/:formId/signatures',
  '/:prefix?/forms/:formId/submit',
  '/attachments/(.*)',
  '/notes/FormQualitySection/(.*)',
];
